import { render, staticRenderFns } from "./UpdateConfigAttendanceEmployee.vue?vue&type=template&id=5b99df62&scoped=true"
import script from "./UpdateConfigAttendanceEmployee.vue?vue&type=script&lang=js"
export * from "./UpdateConfigAttendanceEmployee.vue?vue&type=script&lang=js"
import style0 from "./UpdateConfigAttendanceEmployee.vue?vue&type=style&index=0&id=5b99df62&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b99df62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b99df62')) {
      api.createRecord('5b99df62', component.options)
    } else {
      api.reload('5b99df62', component.options)
    }
    module.hot.accept("./UpdateConfigAttendanceEmployee.vue?vue&type=template&id=5b99df62&scoped=true", function () {
      api.rerender('5b99df62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/UpdateConfigAttendanceEmployee.vue"
export default component.exports